<template lang="pug">
.container-restricao
        div.card-restricao(
            v-if='restricoes.length > 0',
            :class='restricoes[index].inibido !== "undefined" && restricoes[index].inibido ? "camada-inibida" : ""',
            v-for='(restricao, index) in listaRestricoes'
        )
            slot(name='botaoInibir', :restricao='restricoes[index]')
            .card-restricao
                .container-restricao-acoes(
                    v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
                )
                    div
                        el-button(
                            size='small',
                            icon='mdi mdi-crosshairs-gps',
                            @click='aplicarZoomRestricao(index)'
                        )
                slot(name='selecionarRestricao', :restricao='restricoes[index]')
                p
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.aias') }}:
                    |
                    | {{ restricao.aias }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numPol') }}:
                    |
                    | {{ restricao.num_pol }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                    |
                    | {{ formatNumber(restricao.areaHa) }}
                    br
                    //- b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaEmbargadaHa') }}:
                    //- |
                    //- | {{ formatNumber(restricao.area_ha) }}
                    //- br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                    |
                    | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                    
                    Criticidade(
                        v-if='restricao.nivelAlerta'
                        :restricao='restricao'
                    )
</template>
    
    <script>
    import formatters from '@/utils/formatters';
    import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
    
    export default {
        name: 'area-embargada-parana',
    
        emits: ['highlightGeometry'],
    
        components: {
            Criticidade
        },
    
        data() {
            return {};
        },
    
        props: {
            restricoes: {
                type: Array,
                required: true
            },
            geometria: {
                type: Array,
                required: false,
                default: null
            },
            habilitarZoomRestricao: {
                type: Boolean,
                required: false,
                default: false
            }
        },
    
        computed: {
            listaRestricoes: function () {
                return this.restricoes.map(value => {
                    if (value.properties) {
                        return {
                            ...value.properties
                        };
                    }
                    return value;
                });
            }
        },
    
        methods: {
            aplicarZoomRestricao(index) {
                let geometriaQueNaoEstavaDentroDasRestricoes = null;
                if (this.geometria) {
                    geometriaQueNaoEstavaDentroDasRestricoes =
                        this.geometria[index];
                }
                this.$emit(
                    'aplicar-zoom-restricao',
                    this.restricoes[index],
                    geometriaQueNaoEstavaDentroDasRestricoes
                );
            },
            formatNumber(number) {
                if (!number) return '-';
                return formatters.maxFormatNumber(number, 2);
            },
    
            formatNumberPercent(number) {
                if (!number) return '-';
                return formatters.maxFormatNumber(number, 2) + '%';
            }
        }
    };
    </script>
    
    <style lang="scss" scoped>
        .card-restricao {
            margin-top: 3%;
        }
        .id-class {
            word-wrap: break-word;
        }
    </style>
